@if (productGroup) {
  @if (mode === 'legacy') {
    <div class="input-container legacy">
      <div class="input-control"
        [ngClass]="{'has-error': !helpTextForm.controls['help_instructions'].valid && helpTextForm.controls['help_instructions'].touched}">
        <label i18n="Label for product group help text">Product Group Help Text</label>
        <textarea spellcheck="false"
          id="product-group-help-text"
        [formControl]="helpTextForm.controls['help_instructions']"></textarea>
        <app-error-display [control]="helpTextForm.controls['help_instructions']"></app-error-display>
      </div>
      <div class="input-control">
        <label i18n="Label for product group help text">Product Group Spanish Help Text</label>
        <textarea spellcheck="false"
          id="product-group-spanish-help-text"
        [formControl]="helpTextForm.controls['help_instructions_spanish']"></textarea>
      </div>
    </div>
  } @else {
    <div class="input-container">
      <label i18n="Label for product group help text">Product Group Help Text</label>
      <!-- Placeholder: replace with the explanation copy from the design mock. -->
      <p class="helper-text" i18n="Explanation of product group help text">
        Sent when a customer texts HELP, in the customer's language. Help text is optional for each language.
      </p>
      @if (mode === 'denied') {
        <p class="notice" i18n="Shown when the user cannot edit multi-language help text">
          You don't have permission to edit multi-language help text.
        </p>
      } @else if (loadFailed) {
        <p class="notice" role="alert" i18n="Shown when product group help text fails to load">
          Could not load this product group's help text. Reload the page to try again.
        </p>
      } @else if (languages.length === 0) {
        <p class="notice" role="status" i18n="Shown when no languages are fully configured">
          No languages are fully configured yet. Configure STOP and HELP responses in the Inputs tab to enable multilingual help replies.
        </p>
      } @else {
        <select id="product-group-help-text-language" class="form-control"
          aria-label="Help text language"
          [ngModel]="selectedCode" (ngModelChange)="selectedCode = $event">
          @for (language of languages; track language.code) {
            <option [value]="language.code">{{ language.englishName }} ({{ language.nativeName }})</option>
          }
        </select>
        <textarea spellcheck="false"
          id="product-group-help-text"
          maxlength="1600"
          [attr.dir]="direction"
          [ngModel]="text"
          (ngModelChange)="onTextChange($event)"></textarea>
      }
    </div>
  }
}
